import { Table } from "reactstrap";
import { formatDate, formatPrice } from "../../../utils/helper/helpers";
import { Badges } from "../../../AbstractElements";
type Items = { [key: string]: any };

const TableauShowCimaf = ({ versements }: { versements: Items }) => {


    return (
        <Table bordered responsive className="text-center">
            <thead>
                <tr className="f-17">
                    <th scope="col">DATE PAIEMENT</th>
                    <th scope="col">MONTANT TOTAL</th>
                    <th scope="col">MONTANT UTILISÉ</th>
                    <th scope="col">QUANTITE TONNES</th>
                    <th scope="col">MONTANT RESTANT</th>
                </tr>
            </thead>
            <tbody>
                <tr className="f-17">
                    <td className="text-capitalize">{formatDate(versements?.pv_date_paiement)}</td>
                    <td>{formatPrice(versements?.montant)}</td>
                    <td>{formatPrice(versements?.mt_update)}</td>
                    <td>{(Math.round(versements?.quantite_tonne)).toLocaleString("gn-GN")} Tonnes</td>
                    <td>
                        {
                            versements?.mt_update < versements?.montant ? (
                                <Badges color="light-success" className="mb-2 fw-bold text-dark">
                                    {formatPrice(versements?.montant - versements?.mt_update)}
                                </Badges>
                            ) : (
                                <Badges color="light-success" className="mb-2 fw-bold text-dark">
                                    Montant Indisponible
                                </Badges>
                            )
                        }

                    </td>
                </tr>
            </tbody>
        </Table>
    )
}

export default TableauShowCimaf;